import React from 'react'
import { Collapse, Icon } from 'antd';
import { Form, GridView, MasterDetailForm, SimpleView, Widget } from '@digital/ui';

import CrfContaContabilTable from './contaContabilTable';
import { ICrfContaContabilAgrupador } from '@app/api/crf/contaContabil';

const { Panel } = Collapse;

const CrfContaContabilAgrupador = () => {

    const initialValues = {
        contaContabilCcId: '',
        codigo: '',
        descricao: '',
        acronimoAgrupadorId: '',
        disciplinaAgrupadorId: '',
        tipoAgrupadorTipoId: '',
    } as ICrfContaContabilAgrupador;


    return (
        <SimpleView>
            <GridView noform>
                <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="2" header="Conta Contábil Agrupador" style={{ border: 0 }}>
                        <Form initialValues={initialValues}>
                            <CrfContaContabilTable />
                        </Form>
                    </Panel>
                </Collapse>
            </GridView>
        </SimpleView>
    )
}

export default CrfContaContabilAgrupador;